export function distinct(value: any, index: number, self: any) {
  return self.indexOf(value) === index
}

export function distinctBy(array: any[], key: string) {
  return array.filter((value, index, self) => self.map((x) => x[key]).indexOf(value[key]) === index)
}
